import { DIGIDOO_SOCIAL_MEDIA_LINKS, type DigidooSocialMediaKey } from 'common/constants/social-media.constants';

export type DigidooSocialMediaViewLink = {
  key: DigidooSocialMediaKey;
  url: (typeof DIGIDOO_SOCIAL_MEDIA_LINKS)[number]['url'];
  iconPath: (typeof DIGIDOO_SOCIAL_MEDIA_LINKS)[number]['iconPath'];
  labelKey: `myAccount.socialMedia.${DigidooSocialMediaKey}`;
};

export const digidooSocialMediaViewLinks: DigidooSocialMediaViewLink[] = DIGIDOO_SOCIAL_MEDIA_LINKS.map(
  ({ key, url, iconPath }) => ({
    key,
    url,
    iconPath,
    labelKey: `myAccount.socialMedia.${key}`,
  }),
);
